(() => {
  // Before/after comparison, same interaction as the app's divider.
  document.querySelectorAll('[data-ml-demo]').forEach((demo) => {
    const samples = JSON.parse(demo.querySelector('[data-ml-samples]').textContent);
    const compare = demo.querySelector('.ml-compare');
    const before = demo.querySelector('.ml-compare__before');
    const after = demo.querySelector('.ml-compare__after');
    const range = demo.querySelector('.ml-compare__range');
    const zoom = demo.querySelector('[data-ml-zoom]');
    const name = demo.querySelector('[data-ml-name]');
    const dim = demo.querySelector('[data-ml-dim]');
    let current = 0;
    let corner = zoom?.getAttribute('aria-pressed') === 'true';

    const setPos = (value) => compare.style.setProperty('--ml-pos', `${value}%`);
    const render = () => {
      const s = samples[current];
      before.src = corner ? s.cornerBefore : s.before;
      after.src = corner ? s.cornerAfter : s.after;
      before.alt = corner ? `${s.label}, bottom-right corner, with the watermark` : `${s.label} with the watermark`;
      after.alt = corner ? `${s.label}, bottom-right corner, after Markless` : `${s.label} after Markless`;
      compare.style.setProperty('--ml-ratio', corner ? '1 / 1' : s.ratio);
      // In the corner view the watermark sits right of centre; start the divider across it.
      if (!compare.classList.contains('is-touched')) {
        range.value = corner ? 63 : 50;
        setPos(range.value);
      }
      if (name) name.textContent = s.file;
      if (dim) dim.textContent = s.dim;
    };

    range.addEventListener('input', () => {
      setPos(range.value);
      compare.classList.add('is-touched');
    });

    demo.querySelectorAll('[data-ml-sample]').forEach((button) => {
      button.addEventListener('click', () => {
        current = Number(button.dataset.mlSample);
        demo.querySelectorAll('[data-ml-sample]').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        render();
      });
    });

    zoom?.addEventListener('click', () => {
      corner = !corner;
      zoom.setAttribute('aria-pressed', String(corner));
      render();
    });

    // Preload the other samples after the page settles.
    window.addEventListener('load', () => {
      samples.forEach((s) => [s.before, s.after, s.cornerBefore, s.cornerAfter].forEach((src) => { new Image().src = src; }));
    }, { once: true });

    render();
  });

  // Screenshot tabs.
  document.querySelectorAll('[data-ml-tabs]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
      });
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        next.focus();
        select(next);
      });
    });
  });

  // Header border once the page scrolls.
  const header = document.querySelector('.ml-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Gentle reveal on scroll.
  const items = document.querySelectorAll('.ml-reveal');
  if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach((el) => io.observe(el));
  } else {
    items.forEach((el) => el.classList.add('is-in'));
  }
})();
